export const getPropertyDisplayValue = (
    value: string | boolean | null | undefined
): string => {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "boolean") return value ? "Yes" : "No";
    return value;
};

/**
 * Clamp a page-number input string to [1, totalPages].
 * Returns the clamped string, or `null` to signal "reject this keystroke".
 */
export function clampPageInput(
    raw: string,
    totalPages?: number
): string | null {
    if (raw === "") return "";
    const num = parseInt(raw, 10);
    if (isNaN(num)) return null;
    if (num < 1) return "1";
    if (totalPages && num > totalPages) return String(totalPages);
    return raw;
}

/** Convert a nullable page number to its draft-input string representation. */
export function pageNumberToString(
    pageNumber: number | null | undefined
): string {
    return pageNumber != null ? String(pageNumber) : "";
}

export function isEmptyPropertyValue(
    value: string | null | undefined
): boolean {
    return value === null || value === undefined || value.trim() === "";
}
